export default function Version() {
  return <small className="text-muted fst-italic">v0.0.1-beta</small>;
}
